import { render, staticRenderFns } from "./signin_as.vue?vue&type=template&id=1c4cbdfc&lang=html&"
import script from "./signin_as.vue?vue&type=script&lang=js&"
export * from "./signin_as.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports